import React from 'react'

import image2 from '../assets/avatar.png'

// count Up
import CountUp from 'react-countup'

// intersection observer hook
import { useInView } from 'react-intersection-observer'
import { Link } from 'react-scroll'

const About = () => {
  const [ref, inView] = useInView({
    threshold: 0.5,
  })

  return (
    <section id="about" className="mb-[300px] mt-[200px] section" ref={ref}>
      <div className="container mx-auto">
        <div className="flex flex-col gap-y-10 lg:flex-row lg:items-center lg:gap-x-20 lg:gap-y-0 h-screen">
          {/* image */}
          <div className="flex-1">
            <img
              src={image2}
              alt="image of Daniel"
              className="flex-col lg:flex h-[300px] lg:h-[650px] mb-[700px] lg:mb-0  rounded-full mx-auto"
            />
          </div>

          {/* text */}
          <div className="flex-1 mt-[-700px] lg:mt-0" >
            <h2 className="h2 text-accent font-extrabold text-center">About me.</h2>
            <h3 className="h3 mb-4 text-center">
              I'm a Front-end Developer with over 3 years working
              experience.
            </h3>
            <p className='text-justify'>
              I have experience developing user-friendly interfaces that are
              responsive and accessible across multiple devices and platforms. I
              am also proficient in using frameworks and libraries such as
              React, and Tailwind to create scalable and maintainable
              applications.
            </p>

            {/* Counter */}
            <div className="flex mt-5 gap-x-6 lg:gap-x-10 mb-12 justify-between">
              <div>
                <div className="text-[30px] lg:text-[40px] font-tertiary text-gradient p-1">
                  {inView ? <CountUp start={0} end={3} duration={7} /> : 3}+
                </div>
                <div className="font-primary text-sm tracking-[2px]">
                  Years of <br />
                  Experience
                </div>
              </div>
              <div>
                <div className="text-[30px] lg:text-[40px] font-tertiary text-gradient p-1">
                  {inView ? <CountUp start={0} end={350} duration={5} /> : 350}{' '}
                  +
                </div>
                <div className="font-primary text-sm tracking-[2px]">
                  Projects <br />
                  Completed
                </div>
              </div>
              <div>
                <div className="text-[30px] lg:text-[40px] font-tertiary text-gradient p-1">
                  {inView ? <CountUp start={0} end={300} duration={4} /> : 300}+
                </div>
                <div className="font-primary text-sm tracking-[2px]">
                  Satisfied <br />
                  Clients
                </div>
              </div>
            </div>
            <div className="items-center max-w-max gap-x-6 mx-auto">
              <Link smooth={true}
            to="contact">
              <button className="btn btn-lg mr-5">Contact Me</button>
              </Link>
              <a href="#" className="text-gradient btn-link">
                {' '}
                My resume{' '}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default About
